import { render } from "./DisabledOption.vue?vue&type=template&id=bd8867d2"
import script from "./DisabledOption.vue?vue&type=script&lang=js"
export * from "./DisabledOption.vue?vue&type=script&lang=js"
script.render = render

export default script